// extracted by mini-css-extract-plugin
export default {"wrapper":"UFNotuTl391jA3kh32lt","content":"jssOo1GQSv8bQBPwdtYW","collapseBlock":"eZ113VwtGgL_QBycFViZ"};